var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12.5,
  r: 10,
  fill: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.4844 4.01562C18.1406 1.67188 15.3125 0.5 12 0.5C8.6875 0.5 5.85938 1.67188 3.51562 4.01562C1.17188 6.35938 0 9.1875 0 12.5C0 15.8125 1.17188 18.6406 3.51562 20.9844C5.85938 23.3281 8.6875 24.5 12 24.5C15.3125 24.5 18.1406 23.3281 20.4844 20.9844C22.8281 18.6406 24 15.8125 24 12.5C24 9.1875 22.8281 6.35938 20.4844 4.01562ZM18.0938 9.5L10.5 17.0938L5.90625 12.5C5.4375 12.0312 5.4375 11.5625 5.90625 11.0938C6.34375 10.6562 6.8125 10.6562 7.3125 11.0938L10.5 14.2812L16.6875 8.09375C17.1875 7.65625 17.6562 7.65625 18.0938 8.09375C18.5625 8.5625 18.5625 9.03125 18.0938 9.5Z",
  fill: "#001246"
})));
export default SvgIconChecked;